import { useEffect, useState } from "react";

export const useDocumentHiddenFor = (delayMs: number): boolean => {
  const [hiddenLongEnough, setHiddenLongEnough] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;
    const clearTimer = () => {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    };
    const armTimer = () => {
      timer ??= setTimeout(() => {
        setHiddenLongEnough(true);
      }, delayMs);
    };
    const onVisibilityChange = () => {
      if (document.hidden) {
        armTimer();
        return;
      }
      clearTimer();
      setHiddenLongEnough(false);
    };

    if (document.hidden) armTimer();
    document.addEventListener("visibilitychange", onVisibilityChange);
    return () => {
      clearTimer();
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [delayMs]);

  return hiddenLongEnough;
};
